import { createProviderToken } from '@core/common-legacy';
import type { AssistantLinkTarget } from '@core/tellent-assistant-types';

/**
 * Host-provided handler for assistant-generated in-app links. Consulted on
 * activation; returns true when it handled the target (the caller then
 * prevents the default web navigation). Web hosts provide nothing and keep
 * plain anchor behavior.
 */
export type TellentAssistantLinkOpener = (target: AssistantLinkTarget) => boolean;

export const {
  provide: provideTellentAssistantLinkOpener,
  inject: injectTellentAssistantLinkOpener,
} = createProviderToken<TellentAssistantLinkOpener>('TELLENT_ASSISTANT_LINK_OPENER')(false);

/**
 * Host-provided handler for links pointing outside the Tellent apps (candidate
 * sources, model-provided links, help center). Consulted on activation; returns
 * true when it handled the URL (the caller then prevents the default hand-off to
 * the browser). Web hosts provide nothing and keep plain anchor behavior.
 */
export type TellentAssistantExternalLinkOpener = (url: string) => boolean;

export const {
  provide: provideTellentAssistantExternalLinkOpener,
  inject: injectTellentAssistantExternalLinkOpener,
} = createProviderToken<TellentAssistantExternalLinkOpener>(
  'TELLENT_ASSISTANT_EXTERNAL_LINK_OPENER',
)(false);
